/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockFastIcon20Solid = forwardRef('TimeClockFastIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 18a8 8 0 1 0-7.938-9H3.5a2 2 0 0 1 1.732 3H5.5a2 2 0 0 1 1.732 3H8a2 2 0 0 1 1.735 2.996c.088.003.176.004.265.004Zm.48-12.182a.75.75 0 0 0-1.5 0v3.507a2 2 0 0 0 1.085 1.78l3.026 1.554a.75.75 0 1 0 .685-1.334L10.751 9.77a.5.5 0 0 1-.272-.445V5.818Z" }),
        React.createElement("path", { d: "M1.5 16.25a.75.75 0 0 0 0 1.5H8a.75.75 0 0 0 0-1.5H1.5Z" }),
        React.createElement("path", { d: "M.25 14a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H1A.75.75 0 0 1 .25 14Z" }),
        React.createElement("path", { d: "M1.5 10.25a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5h-2Z" })));
});
